import React, { useState, useEffect } from "react";
import { chakras } from "../data/ChakraPrayers";
import ChakraModal from "./ChakraModal";

const ChakraOverlay = () => {
  const [selectedChakra, setSelectedChakra] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  // Detect screen width
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Chakra positions for mobile and desktop
  const mobilePositions = {
    1: { top: "82%", left: "42%" },
    2: { top: "75%", left: "42%" },
    3: { top: "68%", left: "42%" },
    4: { top: "54%", left: "42%" },
    5: { top: "43%", left: "42%" },
    6: { top: "33%", left: "42%" },
    7: { top: "26%", left: "42%" },
  };

  const desktopPositions = {
    1: { top: "80%", left: "42%" },
    2: { top: "74%", left: "42%" },
    3: { top: "67%", left: "42%" },
    4: { top: "54%", left: "42%" },
    5: { top: "42%", left: "42%" },
    6: { top: "33%", left: "42%" },
    7: { top: "26%", left: "42%" },
  };

  const positions = isMobile ? mobilePositions : desktopPositions;

  return (
    <section className="w-full bg-[#f5f9f8] py-16 px-4 sm:px-6 lg:px-20" id="chakra-section">
      <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        {/* Left Column: Chakra Explanation */}
        <div data-aos="fade-right" className="w-full px-4 md:px-10">
          <h2 className="text-3xl md:text-4xl font-bold text-green-800 mb-6">
            Chakras & Subtle System
          </h2>
          <div className="text-gray-700 leading-relaxed space-y-5 text-justify">
            <p>
              Inside every human being there is a network of nerves and sensory organs that interprets the outside physical world.
              At the same time, within us resides a subtle system of channels (nadis) and centers of energy (chakras) which look
              after our physical, intellectual, emotional and spiritual being.
            </p>
            <p>
              Each of the seven chakras has several spiritual qualities. These qualities are intact within us, and even though they
              might not always be manifest, they can never be destroyed. When the Kundalini is awakened, these qualities start
              manifesting spontaneously and express themselves in our life.
            </p>
            <p>
              Through regular meditation, we become very dynamic, creative, confident and at the same time humble, loving and compassionate.
              It’s a process which starts to develop naturally when the Kundalini rises and nourishes our chakras.
            </p>
          </div>
        </div>

        {/* Right Column: Subtle System Image + Chakra Buttons */}
        <div data-aos="fade-left" className="relative w-full max-w-[600px] mx-auto px-4">
          <div className="text-center mb-4">
            <h3 className="text-xl font-semibold text-green-700">Subtle System Diagram</h3>
            <p className="text-gray-600 text-sm">
              Tap on each chakra button to view its corresponding prayer.
            </p>
          </div>

          <div className="relative w-full">
            <img
              src="/Subtle-System.jpg"
              alt="Subtle System"
              className="w-full h-auto rounded-xl shadow-md border border-green-200"
            />

            {chakras.map((chakra) => (
              <div
                key={chakra.id}
                className="absolute group"
                style={{
                  ...positions[chakra.id],
                  transform: "translate(-50%, -50%)",
                }}
              >
                {/* Tooltip */}
                <div className="absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 px-2 py-1 rounded-md text-xs text-white bg-black opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-50">
                  {chakra.name} Chakra
                </div>

                {/* Chakra Button */}
                <button
 className="w-6 h-6 md:w-9 md:h-9 flex items-center justify-center rounded-full text-white font-bold shadow-lg ring-2 ring-white hover:scale-110 transition-transform duration-200 text-xs md:text-base pulse-ring"
  style={{ backgroundColor: chakra.color }}
  onClick={() => setSelectedChakra(chakra)}
  title={`Click to view ${chakra.name} prayer`}
>
  {chakra.id}
</button>
              </div>
            ))}

            <ChakraModal chakra={selectedChakra} onClose={() => setSelectedChakra(null)} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChakraOverlay;
